
import { PopParentElement } from '@components/pop/pop-parent-element';
import { $log } from './logger';
import { POP_ALIGNMENT } from '@components/pop/pop-alignment';
import { POP_DIRECTION } from '@components/pop/pop-direction';
import { PopPositionAndArrow } from '@components/pop/pop-position-and-arrow';
import { getOffset } from './dom';
import { POP_WIDTH_UNIT } from '@components/pop/pop-width-unit';

export function getPopSizePosition(
  parentElement: PopParentElement,
  popoverWidth: number,
  popoverHeight: number,
  alignment: POP_ALIGNMENT,
  direction: POP_DIRECTION,
  overlay: boolean,
  gap: number
): PopPositionAndArrow {

    let {
        top: parentTop,
        left: parentLeft,
        height: parentHeight,
        width: parentWidth,
        rightBorder: parentRightBorder,
        bottomBorder: parentBottomBorder,
        nativeElement
    } = parentElement;

    // if native element is available recalculate parameters since they could have been calculated when the DOM content was still loading
    if (nativeElement) {
        const parentOffset: { top: number, left: number } = getOffset(nativeElement);
        parentTop = parentOffset.top;
        parentLeft = parentOffset.left;
        parentHeight = nativeElement.clientHeight;
        parentWidth = nativeElement.clientWidth;
    }

    let left: number;
    let top: number;

    let sizeAndPosition: PopPositionAndArrow = new PopPositionAndArrow();

    const alignmentAndDirection = direction + '_' + alignment;

    switch (alignmentAndDirection) {
        case POP_DIRECTION.BOTTOM + '_' + POP_ALIGNMENT.LEFT:

            top = parentTop + (overlay ? 0 : parentHeight + gap + parentBottomBorder);
            left = parentLeft;
            break;

        case POP_DIRECTION.BOTTOM + '_' + POP_ALIGNMENT.RIGHT:

            top = parentTop + (overlay ? 0 : parentHeight + gap + parentBottomBorder);
            left = parentLeft - (popoverWidth - parentWidth - parentRightBorder);
            break;

        case POP_DIRECTION.BOTTOM + '_' + POP_ALIGNMENT.CENTER:

            top = parentTop + (overlay ? 0 : parentHeight + gap + parentBottomBorder);
            left = parentLeft - ((popoverWidth - parentWidth) / 2) + (parentRightBorder * 2);
            break;

        case POP_DIRECTION.TOP + '_' + POP_ALIGNMENT.LEFT:

            top = parentTop - (overlay ? ((parentHeight + parentBottomBorder - popoverHeight) * -1) : (popoverHeight + gap));
            left = parentLeft;
            break;

        case POP_DIRECTION.TOP + '_' + POP_ALIGNMENT.RIGHT:

            top = parentTop - (overlay ? ((parentHeight + parentBottomBorder - popoverHeight) * -1) : (popoverHeight + gap));
            left = parentLeft - (popoverWidth - parentWidth) + parentRightBorder;
            break;

        case POP_DIRECTION.TOP + '_' + POP_ALIGNMENT.CENTER:

            top = parentTop - (overlay ? ((parentHeight + parentBottomBorder - popoverHeight) * -1) : (popoverHeight + gap));
            left = parentLeft - ((popoverWidth - parentWidth) / 2) + (parentRightBorder * 2);
            break;

        case POP_DIRECTION.LEFT + '_' + POP_ALIGNMENT.TOP:

            top = parentTop;
            left = parentLeft - gap - popoverWidth;
            break;

        case POP_DIRECTION.LEFT + '_' + POP_ALIGNMENT.CENTER:

            top = parentTop - ((popoverHeight - parentHeight) / 2);
            left = parentLeft - gap - popoverWidth;
            break;
        case POP_DIRECTION.LEFT + '_' + POP_ALIGNMENT.BOTTOM:

            top = parentTop - ((parentHeight + parentBottomBorder - popoverHeight) * -1);
            left = parentLeft - gap - popoverWidth;
            break;

        case POP_DIRECTION.RIGHT + '_' + POP_ALIGNMENT.TOP:

            top = parentTop;
            left = parentLeft + gap + parentWidth + parentRightBorder;
            break;
        case POP_DIRECTION.RIGHT + '_' + POP_ALIGNMENT.CENTER:

            top = parentTop - ((popoverHeight - parentHeight) / 2);
            left = parentLeft + gap + parentWidth + parentRightBorder;
            break;

        case POP_DIRECTION.RIGHT + '_' + POP_ALIGNMENT.BOTTOM:

            top = parentTop - ((parentHeight + parentBottomBorder - popoverHeight) * -1);
            left = parentLeft + gap + parentWidth + parentRightBorder;
            break;

        case POP_DIRECTION.OVERLAY + '_' + POP_ALIGNMENT.TOP:
            left = parentLeft - (popoverWidth - parentWidth - parentRightBorder);
            top = parentTop;
            break;
        case POP_DIRECTION.OVERLAY + '_' + POP_ALIGNMENT.BOTTOM:
            left = parentLeft - (popoverWidth - parentWidth - parentRightBorder);
            top = parentTop - ((parentHeight + parentBottomBorder - popoverHeight) * -1);
            break;
    }

    sizeAndPosition.left = left + POP_WIDTH_UNIT.PX;
    sizeAndPosition.top = top + POP_WIDTH_UNIT.PX;
    sizeAndPosition.arrowClass = alignmentAndDirection;

    return sizeAndPosition;
}

export function isPopoverWithinBoundaries(popoverTop, popoverLeft, popoverWidth, popoverHeight, windowWidth, windowHeight): boolean {
    return !(popoverTop < 1 || popoverLeft < 1 ||
      (popoverLeft + popoverWidth) > windowWidth || (popoverTop + popoverHeight) > windowHeight);
}

export function normalizePopDirection(popDirection: POP_DIRECTION, fallbackPopDirection: POP_DIRECTION): POP_DIRECTION {
    if (fallbackPopDirection === POP_DIRECTION.OPPOSITE) {
        if (popDirection === POP_DIRECTION.BOTTOM) {
            return POP_DIRECTION.TOP;
        } else if (popDirection === POP_DIRECTION.TOP) {
            return POP_DIRECTION.BOTTOM;
        } else if (popDirection === POP_DIRECTION.LEFT) {
            return POP_DIRECTION.RIGHT;
        } else if (popDirection === POP_DIRECTION.RIGHT) {
            return POP_DIRECTION.LEFT;
        }
    } else {
        return fallbackPopDirection;
    }
}
